import { Component, OnInit } from '@angular/core';
import { HubConnection } from '@aspnet/signalr';
import * as signalR from '@aspnet/signalr';

@Component({
  selector: 'app-home-component',
  templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit {
  private _hubConnection: HubConnection | undefined;
  public async: any;
  message = '';
  messages: { user: string; msg: string }[] = [];

  constructor() {}
  ngOnInit() {
    const user = JSON.parse(sessionStorage.getItem('currentUser'));
    this._hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(`http://localhost:8888/chathub?userId=${user.userName}`)
      .configureLogging(signalR.LogLevel.Trace)
      .build();

      this._hubConnection.on('ReceiveMessage', (data: any) => {
      console.log(data);
      const received = `${data.user} Received: ${data.msg}`;
      this.messages.push({ user: data.user, msg: received });
    });

    this._hubConnection.start().catch(err => {
      console.error(err.toString());
      console.error(err);
    });
  }

  public sendMessage(): void {
    const user = JSON.parse(sessionStorage.getItem('currentUser'));
    const data = `${this.message}`;
    if (this._hubConnection) {
      this._hubConnection.invoke('SendMessage', '8', data);
    }
    this.messages.push({ user: user.userName, msg: data });
  }
}
